import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { CalendarEvent } from 'calendar-utils';
import { isSameDay, isSameMonth } from 'ngx-bootstrap/chronos';
import { of, Subject } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { ModalComponent } from 'src/app/shared/components/modal/modal.component';
import { HomeService } from '../../home/home.service';
import { ProfileService } from '../../profile/profile.service';
import { ActivityManagementService } from '../activity-management.service';
import { ModalConsultComponent } from './modal-consult/modal-consult.component';
import { DatePipe } from 'src/app/shared/pipe/date.pipe';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import { Router } from '@angular/router';
import { GobalFunctionService } from 'src/app/core/services/gobal/gobal-function.service';

@Component({
  selector: 'app-consult',
  templateUrl: './consult.component.html',
  styleUrls: ['./consult.component.scss']
})
export class ConsultComponent implements OnInit {
  @ViewChild('modalContent', { static: true }) modalContent: TemplateRef<any>;

  role: string;
  profile;
  allConsult;
  allEvent;
  allEventCopy;
  viewDate: Date = new Date();
  modalData: {
    action: string;
    event: CalendarEvent;
  };
  refresh: Subject<any> = new Subject();
  userId: string;
  colors: any = {
    green: {
      primary: '#32BEA6'
    },
    gray: {
      primary: '#DDDDDD'
    }
  };
  maxDate = new Date().getFullYear() + 1 + '-' + new Date().getMonth() + 1;
  events: CalendarEvent[] = [];
  activeDayIsOpen: boolean = false;
  monthSelected: Date = null;
  isLoading: boolean = false;

  constructor(
    public matDialog: MatDialog,
    private activityManagementService: ActivityManagementService,
    private homeService: HomeService,
    private profileService: ProfileService,
    private router: Router,
    private gobalFunctionService: GobalFunctionService
  ) {
  }

  ngOnInit(): void {
    this.gobalFunctionService.setTitle('การจัดการ Consult');
    this.homeService.getRole().pipe(
      switchMap(r => {
        // // console.log(r);
        this.role = r.result.ROLE;

        if (this.role === 'admin') {
          return this.activityManagementService.getAllConsult().pipe(
            map(c => {
              this.allConsult = c.result;
            })
          )
        } else if (this.role === 'teacher' || this.role === 'psychologist') {
          return this.profileService.getProfile().pipe(
            map(p => {
              this.userId = p.result.USER_ID;
              this.profile = p.result;
              // // console.log(this.profile);

              return this.activityManagementService.getCalendaConsultByUser(this.userId)
            })
          )
        }
      }),
      catchError((err) => {
        alert(err.error.message);
        return of(false);
      })
    ).subscribe()
  }

  dayClicked({ date, events }: { date: Date; events: CalendarEvent[] }): void {
    if (isSameMonth(date, this.viewDate)) {
      if ((isSameDay(this.viewDate, date) && this.activeDayIsOpen === true) || events.length === 0) {
        this.activeDayIsOpen = false;
      } else {
        this.activeDayIsOpen = true;
      }
      this.viewDate = date;
    }
  }

  getMonth(date) {
    let d = new Date(date);
    let longThaiMonth = [
      'มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน',
      'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'
    ];
    return longThaiMonth[d.getMonth()] + ' ' + (d.getFullYear() + 543);
  }

  handleEvent(event: CalendarEvent): void {
    let consult;

    this.allEvent.forEach((e) => {
      // find consult
      if (e.CONSULT_ID === event.id) consult = e;
    });

    // // console.log(consult);

    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.id = 'modalConfirm';
    dialogConfig.width = '450px';
    dialogConfig.autoFocus = false;

    if (consult.CONSULT_STATUS === 'joined') {
      dialogConfig.data = {
        title: 'รายละเอียด',
        description: ``,
        actionBtnText: 'บันทึก',
        uid: consult.USER_ID,
        value: consult,
        isEdit: true,
        isJoined: true
      }
    } else if (consult.CONSULT_STATUS === 'busy') {
      dialogConfig.data = {
        title: 'แก้ไขช่วงเวลา',
        description: ``,
        actionBtnText: 'บันทึก',
        uid: consult.USER_ID,
        value: consult,
        isEdit: true,
        isJoined: false,
      }
    }
    // // console.log(dialogConfig);

    const modal = this.matDialog.open(ModalConsultComponent, dialogConfig);
    modal.afterClosed().pipe(
      switchMap(res => {
        let dialogConfig2;
        dialogConfig2 = new MatDialogConfig();
        dialogConfig2.disableClose = true;
        dialogConfig2.id = 'modalConfirm';
        dialogConfig2.width = '450px';
        dialogConfig2.autoFocus = false;

        if (res.status) {
          dialogConfig2.data = {
            title: "ยืนยันการแก้ไข",
            description: `คุณต้องการแก้ไข consult เวลา ${this.addZeroBefore(res.obj.CONSULT_DATE_START.getHours())}:00 - ${this.addZeroBefore(res.obj.CONSULT_DATE_END.getHours())}:00 น. ใช่หรือไม่`,
            actionBtnText: "ยืนยัน",
            cancleBtnText: "ยกเลิก"
          }
        }

        if (res.isDelete) {
          dialogConfig2.data = {
            title: "ยืนยันการลบ",
            description: `คุณต้องการลบ consult เวลา ${this.addZeroBefore(res.obj.CONSULT_DATE_START.getHours())}:00 - ${this.addZeroBefore(res.obj.CONSULT_DATE_END.getHours())}:00 น. ใช่หรือไม่`,
            isDelete: true,
            actionBtnText: "ยืนยัน",
            cancleBtnText: "ยกเลิก"
          }
        }

        if (dialogConfig2.data) {
          let modal2 = this.matDialog.open(ModalComponent, dialogConfig2);
          return modal2.afterClosed().pipe(
            switchMap(r => {
              if (r) {
                // console.log(res.obj);
                return this.activityManagementService.createConsult([res.obj]).pipe(
                  map(() => {
                    this.getCalendaConsultByUser(consult.USER_ID);
                  }),
                );
              } else {
                // แทนค่าก่อนแก้ไข
                this.allEvent = JSON.parse(JSON.stringify(this.allEventCopy));
                return of(null);
              }
            }),
          );
        } else {
          // แทนค่าก่อนแก้ไข
          this.allEvent = JSON.parse(JSON.stringify(this.allEventCopy));
          return of(null);
        }
      })
    ).subscribe()
  }

  exportExcelByMonth() {
    let startDate = new Date(this.monthSelected);
    let lastDate = new Date(startDate.getFullYear(), startDate.getMonth() + 1, 0, 7);
    let longThaiMonth = [
      'มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน',
      'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'
    ];
    const body = {
      FROM_DATE: startDate,
      TO_DATE: lastDate
    }
    this.isLoading = true;

    this.activityManagementService.exportAllCalendaConsultByDate(body).pipe(
      map(res => {
        const _data = [];
        const _data2 = [];
        // console.log(res);

        if (res.result.length > 0) {
          res.result.map(d => {
            _data.push({
              'CONSULT_ID': d.CONSULT_ID,
              'อาจารย์': d.USERNAME,
              'ประเภท': d.CONSULT_TYPE,
              'วัน-เวลาเข้ารับ consult': `${new DatePipe().transform(d.CONSULT_DATE_START.toString(), 'date')} ${this.addZeroBefore(new Date(d.CONSULT_DATE_START).getHours())}:00 - ${this.addZeroBefore(new Date(d.CONSULT_DATE_END).getHours())}:00 น.`,
              'จำนวนผู้เข้าร่วม': d.CONSULT_COUNT_REGISTER,
              'จำนวนผู้เข้าร่วมสูงสุด': d.CONSULT_MAX
            })

            d.register.map(registed => {
              _data2.push({
                'CONSULT_ID': d.CONSULT_ID,
                'อาจารย์': d.USERNAME,
                'ประเภท': registed.CONSULT_TYPE,
                'ลักษณะการเข้าร่วม': d.CONSULT_TYPE,
                'หัวข้อการเข้าร่วม': registed.CONSULT_CATEGORY,
                'วัน-เวลาเข้ารับ consult': `${new DatePipe().transform(d.CONSULT_DATE_START.toString(), 'date')} ${this.addZeroBefore(new Date(d.CONSULT_DATE_START).getHours())}:00 - ${this.addZeroBefore(new Date(d.CONSULT_DATE_END).getHours())}:00 น.`,
                'รายละเอียดเพิ่มเติม': registed.MORE_DETAIL,
                'ประเภทการเข้าร่วม': registed.CONSULT_JOIN_TYPE,
                'จำนวนผู้เข้าร่วมสูงสุด': d.CONSULT_MAX,
                'วิธีการเข้าร่วม': registed.CONSULT_SOLUTION,
                'จองแล้ว': `${registed.CUSTOMER_NAME} (${registed.CONSULT_COUNT_REGISTER} คน)`,
                'ชำระทั้งหมด': registed.CONSULT_TOTAL_PRICE + ' บาท',
                'สถานะการชำระ': registed.CONSULT_STATUS,
              })
            })
          })
        } else {
          _data.push({
            'CONSULT_ID': '',
            'อาจารย์': '',
            'ประเภท': '',
            'วัน-เวลาเข้ารับ consult': '',
            'จำนวนผู้เข้าร่วม': '',
            'จำนวนผู้เข้าร่วมสูงสุด': ''
          })

          _data2.push({
            'CONSULT_ID': '',
            'อาจารย์': '',
            'ประเภท': '',
            'ลักษณะการเข้าร่วม': '',
            'หัวข้อการเข้าร่วม': '',
            'วัน-เวลาเข้ารับ consult': '',
            'รายละเอียดเพิ่มเติม': '',
            'ประเภทการเข้าร่วม': '',
            'จำนวนผู้เข้าร่วมสูงสุด': '',
            'วิธีการเข้าร่วม': '',
            'จองแล้ว': '',
            'ชำระทั้งหมด': '',
            'สถานะการชำระ': '',
          })
        }

        const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(_data);
        const worksheet2: XLSX.WorkSheet = XLSX.utils.json_to_sheet(_data2);
        const workbook: XLSX.WorkBook = {
          Sheets: {
            'ตารางนัดหมายทั้งหมด': worksheet,
            'ลงทะเบียน': worksheet2
          },
          SheetNames: ['ตารางนัดหมายทั้งหมด', 'ลงทะเบียน'],
        };

        const excelBuffer: any = XLSX.write(workbook, {
          bookType: 'xlsx',
          type: 'array',
        });

        const data: Blob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });

        FileSaver.saveAs(data, `ตารางนัดหมายเดือน_${longThaiMonth[startDate.getMonth()]}_${startDate.getFullYear()}`);
        this.isLoading = false;
      }),
      catchError((err) => {
        alert(err.error.message);
        return of(false);
      })
    ).subscribe()
  }

  closeOpenMonthViewDay() {
    this.activeDayIsOpen = false;
    this.getCalendaConsultByUser(this.userId);
  }

  consultSelected(e) {
    this.userId = e.target.value
    this.getCalendaConsultByUser(this.userId)
  }

  storeId(id) {
    this.router.navigate(['activity-management/consult/manage-consult'], { state: { 'consult-uid': id } });
  }

  getCalendaConsultByUser(id) {
    const m = this.viewDate.getMonth() + 1;
    const body = {
      USER_ID: id,
      MONTH: m.toString(),
      YEAR: this.viewDate.getFullYear().toString()
    }
    this.events = []
    this.activityManagementService.getCalendaConsultByUser(body).subscribe(res => {
      this.allEvent = res.result;
      this.allEventCopy = JSON.parse(JSON.stringify(res.result));

      this.setEvent(res.result);
    })
  }

  setEvent(e) {
    let color;
    // console.log(e);

    for (let i = 0; i < e.length; i++) {
      let start = new Date(e[i].CONSULT_DATE_START);
      let end = new Date(e[i].CONSULT_DATE_END);

      if (e[i].CONSULT_STATUS === 'busy') {
        color = this.colors.green;
      } else if (e[i].CONSULT_STATUS === 'joined') {
        color = this.colors.gray;
      }

      let event = {
        id: e[i].CONSULT_ID,
        start: start,
        end: end,
        title: `${this.addZeroBefore(start.getHours())}: ${this.addZeroBefore(start.getMinutes())} - ${this.addZeroBefore(end.getHours())}: ${this.addZeroBefore(end.getMinutes())} น. &nbsp(${e[i].CONSULT_TYPE}) &nbsp ${this.getSubstring(e[i].CONSULT_OBJECT ? '|' : '')} &nbsp ${this.getSubstring(e[i].CONSULT_OBJECT)} `,
        color: color,
      }
      this.events.push(event);
    }
    this.refresh.next();
  }

  addZeroBefore(n) {
    return (n < 10 ? '0' : '') + n;
  }

  getSubstring(s): string {
    if (s.length > 100)
      return s.substring(0, 100) + '...'
    else return s
  }

}


